function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import cn from 'classnames';
import { Card, Column, TextButton, useOverlayContext } from 'seagull';
import { ArrowDownFill } from 'seagull/icons';
import TutorialVideosModal from "../../../../components/NavigationAndStructure/HelpMenu/TutorialVideosModal/TutorialVideosModal";
import { openInNewTabProps } from "../../../../constants";
import { useIoContext } from "../../../../contexts";
import { ExternalLink, useHelpMenuExternalLinks } from "../../../../hooks/useHelpMenuExternalLinks";
import { useTutorialVideos } from "../../../../hooks/useTutorialVideos/useTutorialVideos";
import styles from "./HelpCard.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const HelpCard = _ref => {
  let {
    className,
    testId
  } = _ref;
  const {
    externalLinks
  } = useHelpMenuExternalLinks({
    hideWhatsNew: true
  });
  const {
    videos
  } = useTutorialVideos();
  const {
    showModal
  } = useOverlayContext();
  const {
    YoutubePlayer
  } = useIoContext();
  return /*#__PURE__*/_jsxs(Card, {
    className: cn(styles.card, className),
    "data-testid": testId,
    children: [/*#__PURE__*/_jsx(Card, {
      className: styles.container,
      "data-testid": "tutorial-video",
      as: "button",
      onClick: () => showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;
          return /*#__PURE__*/_jsx(TutorialVideosModal, {
            dismissModal: dismissModal
          });
        }
      }),
      children: /*#__PURE__*/_jsx(YoutubePlayer, {
        className: styles.thumbnail,
        playIcon: /*#__PURE__*/_jsx(ArrowDownFill, {
          className: styles.playIcon
        }),
        light: true,
        height: 174,
        width: 278,
        url: "https://youtu.be/".concat(videos[0].id)
      })
    }), /*#__PURE__*/_jsx(Column, {
      children: /*#__PURE__*/_jsx(Column, {
        className: styles.helpCardColumn,
        children: externalLinks.map(link => /*#__PURE__*/_jsx(TextButton, _objectSpread(_objectSpread({
          "data-testid": "help-card-link-".concat(link.label),
          className: cn(styles.button),
          prefixIcon: link.icon ? /*#__PURE__*/_jsx(link.icon, {}) : null,
          underline: "none",
          weight: "normal",
          variant: "paragraph2"
        }, link.type === ExternalLink.Link ? _objectSpread({
          as: 'a',
          href: link.href
        }, openInNewTabProps) : {
          onClick: link.onClick
        }), {}, {
          children: link.label
        }), link.label))
      })
    })]
  });
};
export default HelpCard;